import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-print-button',
  standalone: false,
  templateUrl: './print-button.component.html',
  styleUrl: './print-button.component.scss'
})
export class PrintButtonComponent {
  @Output() togglePrint = new EventEmitter<void>();

  handlePrint() {
    this.togglePrint.emit();
  }
}
